export const TESTS = {
    SLP_AA: 'slpAA',
    SLP_2089V: 'slp2089v',
    SLP_2194V: 'slp2194v',
    SLP_2134: 'slp2134',
    GDPR: 'ha_gdpr_banner'
};

export const EVALUATE = [
    TESTS.SLP_AA,
    TESTS.SLP_2089V,
    TESTS.SLP_2194V,
    TESTS.SLP_2134,
    TESTS.GDPR
];

export const EVALUATE_AND_LOG = [];

export const getValue = (abacus, test) =>
    abacus && abacus[test] ?
        abacus[test].value :
        null;
